import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService, PagedList } from '@app/core/index';
import { getFileNameFromResponseContentDisposition, saveFile } from '@app/shared';
import { CaseListFilterOptions } from '@app/shared/types/case-list-filter-options';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IAndR } from '../types/i-and-rs';
import { IAndRCreate } from '../types/i-and-rs-create';
import { GetIAndRsListPayload } from '../types/i-and-rs-params';

@Injectable({
   providedIn: 'root'
})
export class IAndRListService {
   static injectName = 'iAndRListService';
   private baseUrl = 'api/informationandreferrals';

   constructor(private http: HttpService) { }

   getIAndRList(criteria: GetIAndRsListPayload): Observable<PagedList<IAndR>> {
      const url = `${this.baseUrl}/list/filtered`;
      return this.http.post<PagedList<IAndR>>(url, criteria);
   }

   getIAndRExport(criteria: GetIAndRsListPayload) {
      const url = `${this.baseUrl}/list/export`;
      return this.http.post<HttpResponse<Blob>>(url, criteria, { responseType: 'blob', observe: 'response' }).pipe(
         tap(res => {
            const fileName = getFileNameFromResponseContentDisposition(res);
            saveFile(res.body, fileName);
         })
      );
   }

   createIAndRCase(data: IAndRCreate): Observable<IAndR> {
      const url = `${this.baseUrl}`;
      return this.http.post<IAndR>(url, data);
   }

   deleteIAndRCase(id: string) {
      const url = `${this.baseUrl}/${id}`;
      return this.http.delete(url);
   }

   getFilterOptions(): Observable<CaseListFilterOptions> {
      const url = `api/configuration/list/options`;
      return this.http.post<CaseListFilterOptions>(url, { CaseType: 'i-and-r' });
   }
}